import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { FormArray, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import * as moment from 'moment';
import { RouteService } from 'src/app/core/services';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.css']
})
export class AccountInfoComponent implements OnInit {

  // Pattern
  phonePattern ="^((\\+91-?)|0)?[0-9]{10}$";

  // For datepicker
  minDate = "1800-01-01"
  maxDate = moment(new Date()).format('YYYY-MM-DD');

  // User object
  user = {
    email: '',
    password: '',
    firstName: '',
    middleInitial: '',
    lastName: '',
    ageUnder18: false,
    primaryRole: '',
    primaryRoleOther: '',
    companyName: '',
    dob: '',
    race: '',
    ethnicity: '',
    disabled: '',
    numberOfChildren: '',
    maritalStatus: '',
    familyStatus: '',
    education: '',
    annualIncome: '',
    sourceOfIncome: '',
    streetAddress: '',
    secondary: '',
    phone: '',
    city: '',
    state: '',
    zipCode: '',
    county: '',
    primaryResidence: '',
    livingSituation: '',
  }

  // Race logic
  userRaces: any = [];
  racesTrue: any = [0,0,0,0,0,0];

  // Password object
  update = {
    password: '',
    confirmPassword: ''
  }

  // Initialize form, only using race in this
  form = this.fb.group({
    checkArray: this.fb.array([])
  })

  // Template variables
  userLoaded = false;
  resetMode = false;
  isActiveDiv = false;

  // Role values
  primaryRoles = [
    { name: 'Renter', value: 'Renter' },
    { name: 'Housing Provider – Owner', value: 'Housing Provider – Owner' },
    { name: 'Housing Provider – Property Management', value: 'Housing Provider – Property Management' },
    { name: 'Other', value: 'Other' },
  ];

  // Race values
  races = [
    { name: 'American Indian or Alaska Native', value: 'American Indian or Alaska Native' },
    { name: 'Asian', value: 'Asian' },
    { name: 'Black or African American', value: 'Black or African American' },
    { name: 'Native Hawaiian or Other Pacific Islander', value: 'Native Hawaiian or Other Pacific Islander' },
    { name: 'White', value: 'White' },
    { name: 'Prefer Not to Say', value: 'Prefer Not to Say' }
  ];

  constructor(private auth: AuthService, private router: Router, private routeService: RouteService, private flashMessage: FlashMessagesService, private fb: FormBuilder) { }

  // When the page is loaded, pull the profile infomation
  ngOnInit(): void {

    // Use auth service to send request
    this.auth.getProfile().toPromise().then((profile: any) => {
      // Assign response to user object
      this.user = profile.user;
      this.userLoaded = true;

      this.initValidators();

      // Race logic
      this.userRaces = this.user.race.split(",");

      // Precheck boxes
      for(var i = 0; i < this.races.length; i++) {
        this.userRaces.forEach((element: any) => {
          if (this.races[i].name == element) {
            this.racesTrue[i] = 1;
            const checkArray: FormArray = this.form.get('checkArray') as FormArray;
            checkArray.push(new FormControl(this.races[i].value));
          }
        });
      };
    });
  }

  initValidators() {
    const checkArray = this.form.controls['checkArray'];

    if (this.user.ageUnder18) {
      checkArray.clearValidators();
      checkArray.updateValueAndValidity();
    } else {
      checkArray.setValidators([Validators.required]);
      checkArray.updateValueAndValidity();
    }
  }

  setAgeUnder18(enabled: boolean) {
    this.user.ageUnder18 = enabled;
    this.initValidators();
  }

  // Update profile information
  onUpdate(f: NgForm) {

    // Update user profile with information
    if (this.form.valid) {

      // Update user in local storage
      this.auth.user = {
        email: this.auth.user.email,
        id: this.auth.user.id,
        name: this.user.firstName + " " + this.user.lastName,
        ageUnder18: this.user.ageUnder18
      }
      this.auth.updateUserDataStored();

      // Race logic
      this.user.race = this.form.value.checkArray.toString();

      if (this.user.primaryRole && this.user.primaryRole !== 'Other') {
          this.user.primaryRoleOther = '';
      }

      if (this.user.primaryRole && this.user.primaryRole !== 'Housing Provider – Owner' && this.user.primaryRole !== 'Housing Provider – Property Management') {
          this.user.companyName = '';
      }

      // this.user.dob = new Date(this.user.dob).toLocaleDateString("en-US");
      this.auth.updateProfile(this.user).toPromise().then((res: any) => {

        // Successfully updated
        if (res.success) {
          // Display update success to user
          this.flashMessage.show("Account updated.", {
            cssClass: 'alert-success',
            timeout: 5000
          });

          this.routeService.scrollToTop();

          // Reset submitted status to clear validation errors
          f.resetForm(f.value);
        }
      });
    }
  }

  // Submit reset password
  onSubmit() {
    this.resetMode = false;

    // Send request
    this.auth.resetpasswordloggedin({ password: this.update.password, user: this.auth.user }).toPromise().then((data: any) => {

      // Successful reset
      if (data.success) {

        // Show success
        this.flashMessage.show("Password successfully reset.", {
          cssClass: 'alert-success',
          timeout: 3000
        });
      }

      // Password reset failed
      else {
        this.flashMessage.show("Password reset failed.", {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }

      // Reset
      this.update.password = '';
    this.update.confirmPassword = '';
    });
  }



  // Listen to when the checkbox changes
  onCheckboxChange(e: any) {
    const checkArray: FormArray = this.form.get('checkArray') as FormArray;

    // Push in a race if it has been checked
    if (e.target.checked) {
      checkArray.push(new FormControl(e.target.value));
    }

    // If it isn't checked, remove it from the checkArray
    else {
      let i: number = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }
}
